import cx from 'classnames';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Footer({
  flagsTitle,
  flags,
  sections,
  copyRights,
  className,
  ...spreadProps
}) {
  return /*#__PURE__*/_jsx("footer", {
    className: cx('wa-footer container-fluid', className),
    ...spreadProps,
    children: /*#__PURE__*/_jsxs("div", {
      className: "container",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "wa-footer__flags",
        children: [/*#__PURE__*/_jsx("h6", {
          className: "wa-footer__title",
          children: flagsTitle
        }), flags.map((flag, index) => {
          return /*#__PURE__*/_jsx("a", {
            className: "wa-footer__flag",
            href: flag.href,
            children: /*#__PURE__*/_jsx("picture", {
              children: /*#__PURE__*/_jsx("img", {
                alt: flag.alt,
                src: flag.img,
                loading: "lazy",
                width: 34,
                height: 34
              })
            })
          }, index);
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "row",
        children: sections.map((section, key) => {
          return /*#__PURE__*/_jsx(FooterSection, {
            section: section
          }, key);
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "row wa-footer__copy-rights",
        children: /*#__PURE__*/_jsx("div", {
          className: "col-sm-12",
          children: /*#__PURE__*/_jsx("strong", {
            children: copyRights
          })
        })
      })]
    })
  });
}
function FooterSection({
  section
}) {
  return /*#__PURE__*/_jsxs("div", {
    className: "col-md-4",
    children: [/*#__PURE__*/_jsx("h6", {
      className: "wa-footer__title",
      children: section.title
    }), /*#__PURE__*/_jsx("ul", {
      className: "wa-footer__list",
      children: (section?.links ?? []).map((link, index) => {
        return /*#__PURE__*/_jsx(SectionItem, {
          item: link
        }, index);
      })
    })]
  });
}
function SectionItem({
  item
}) {
  const {
    href,
    title,
    tooltip
  } = item;
  return /*#__PURE__*/_jsxs("li", {
    className: "wa-footer__list-item",
    children: [/*#__PURE__*/_jsx("a", {
      className: "wa-footer__list-link",
      href: href,
      children: title
    }), typeof tooltip === 'string' ? /*#__PURE__*/_jsx("span", {
      className: "wa-footer-item-tooltip",
      dangerouslySetInnerHTML: {
        __html: tooltip
      }
    }) : null]
  });
}
export default Footer;